// extracted by mini-css-extract-plugin
module.exports = {"select":"OptionsInput_select__VkrXT","label":"OptionsInput_label__2LFvK","error":"OptionsInput_error__wGE4o"};